"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableBody = exports.StyledTableHeadButton = exports.StyledTableHead = exports.StyledTable = exports.StyledTableWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styleTokens = require("./shared/styleTokens.js");

var StyledTableWrapper = _styledComponents.default.div.withConfig({
  displayName: "sortableTablestyle__StyledTableWrapper",
  componentId: "km83ev-0"
})(["color:", ";padding:0 1.5rem;width:100%;background:", ";border:1px solid #ebedee;border-radius:8px;margin:1rem 0;"], _styleTokens.COLOR.black, _styleTokens.COLOR.white);

exports.StyledTableWrapper = StyledTableWrapper;

var StyledTable = _styledComponents.default.table.withConfig({
  displayName: "sortableTablestyle__StyledTable",
  componentId: "km83ev-1"
})(["width:100%;background:", ";border:none;border-radius:8px;text-align:left;border-collapse:collapse;"], _styleTokens.COLOR.white);

exports.StyledTable = StyledTable;

var StyledTableHead = _styledComponents.default.thead.withConfig({
  displayName: "sortableTablestyle__StyledTableHead",
  componentId: "km83ev-2"
})(["th{text-align:left;text-transform:capitalize;font-weight:600;font-size:12px;line-height:18px;color:", ";border-bottom:1px solid ", ";&:hover{border-bottom:1px solid ", ";}}"], _styleTokens.COLOR.black, _styleTokens.COLOR.greyOpacity01, _styleTokens.COLOR.grey);

exports.StyledTableHead = StyledTableHead;

var StyledTableHeadButton = _styledComponents.default.button.withConfig({
  displayName: "sortableTablestyle__StyledTableHeadButton",
  componentId: "km83ev-3"
})(["color:", ";cursor:", ";border:0;background:none;border-radius:none;font-family:inherit;font-weight:700;font-size:inherit;padding:1.3rem 0.2rem;width:100%;display:flex;align-items:center;svg{display:inline-block;margin-left:1rem;", "}"], _styleTokens.COLOR.black, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, ''
/* opacity: ${(props) => (props.sortOrder ? 1 : 0)}; */
);

exports.StyledTableHeadButton = StyledTableHeadButton;

var StyledTableBody = _styledComponents.default.tbody.withConfig({
  displayName: "sortableTablestyle__StyledTableBody",
  componentId: "km83ev-4"
})(["td{border-bottom:1px solid ", ";font-size:12px;line-height:18px;padding:1rem 0.2rem;}tr:last-of-type{td{border-bottom:1px solid transparent;}}tr:hover{td{border-bottom:1px solid ", ";}}"], _styleTokens.COLOR.greyOpacity01, _styleTokens.COLOR.grey);

exports.StyledTableBody = StyledTableBody;